// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParticleIcon_wrapper_20G-j","content":"ParticleIcon_content_2M57v","icon":"ParticleIcon_icon_1RWrN"};